import React from 'react';
import {AnchorButton, Callout, Intent} from '@blueprintjs/core';
import {IconNames} from '@blueprintjs/icons';

import config from '../../../../config';
import {Result} from '../components';
import {getFileType} from './utils';
import {ACTION_TYPES} from './constants';

interface TableauResultProps {
  key?: string;
  uid?: string;
  result: any;
}

const ErrorMessage = ({result}: any) => {
  const executionEnd = result?.value?.created_on ? new Date(result?.value?.created_on) : null;
  const response = result?.value?.response_json || {};
  const {error, code} = response;

  return (
    <>
      {executionEnd && <div>Execution end: {executionEnd.toLocaleString()}</div>}
      <div dangerouslySetInnerHTML={{__html: 'Error: ' + error}}></div>
      {!!code && <div>Code: {code}</div>}
    </>
  );
};

const SuccessMessage = ({uid, result}: any) => {
  const executionEnd = result?.value?.created_on ? new Date(result?.value?.created_on) : null;
  const response = result?.value?.response_json || {};
  const {name, url, action} = response;
  const fileType = getFileType(action);

  const isPresignedURL = url && url.includes('Expires') && url.includes('Signature');

  let downloadUrl = isPresignedURL ?
    url : `${config.app.url}/api/v1/block/${uid}/export/${result.key}?type=${fileType}`;

  let rows: any = undefined;

  if (action === ACTION_TYPES.VIEW_CSV && response.hasOwnProperty('rows')) {
    rows = response.rows;
  }

  return (
    <Callout
      intent={Intent.SUCCESS}
      icon={IconNames.TICK}
      title={name}
    >
      {executionEnd && <div>Execution end: {executionEnd.toLocaleString()}</div>}
      {rows !== undefined && <div>Rows returned: {rows}</div>}
      {
        fileType !== 'no_type' && (
          <AnchorButton
            text={`Download ${fileType}`}
            href={downloadUrl}
            target="_blank"
            rel="noopener noreferrer"
            icon={IconNames.CLOUD_DOWNLOAD}
            intent={Intent.SUCCESS}
            style={{marginTop: '10px'}}
          />
        )
      }
    </Callout>
  );
};

const TableauResult = ({
  uid,
  result,
}: TableauResultProps) => {
  return (
    <Result
      result={result}
      successElement={<SuccessMessage uid={uid} result={result}/>}
      failedTitle="Execution failed"
      failedDescription={<ErrorMessage result={result}/>}
    />
  );
};

export default TableauResult;
